import { AppFooter, AppFooterLink, spacer12 } from '@spotify-internal/encore-web';
import { UserEntity } from 'libs/services/s4pTypes';
import { cookiesUrl, privacyPolicyUrl, termsAndConditionsUrl } from 'libs/utils/externalUrls';
import styled from 'styled-components';
import { useT } from '@spotify-internal/i18n-core';

const StyleWrapper = styled.div`
  padding: 0 ${spacer12};
`;

type FooterProps = {
  user: UserEntity;
};

const Footer = ({ user }: FooterProps) => {
  const t = useT();
  const footerLinks = [
    {
      label: t(
        'HREF_FOOTER_0',
        'Legal',
        'Link to Spotify for Publishing Terms and Conditions of Use document',
      ),
      href: termsAndConditionsUrl(user),
    },
    {
      label: t('HREF_FOOTER_1', 'Privacy', 'Link to Spotify Privacy Policy document'),
      href: privacyPolicyUrl(user),
    },
    {
      label: t('HREF_FOOTER_2', 'Cookies', 'Link to Spotify Cookie Policy document'),
      href: cookiesUrl(user),
    },
  ];

  return (
    <StyleWrapper>
      <AppFooter
        copyrightYear={2022}
        list={footerLinks.map((link) => (
          <AppFooterLink key={link.label} href={link.href} target="_blank">
            {link.label}
          </AppFooterLink>
        ))}
      />
    </StyleWrapper>
  );
};

export default Footer;
